export default __webpack_public_path__ + "static/media/note.732813e5.svg";